import { createRouter, createWebHistory } from "vue-router";
import api from "@/api";
import Const from "@/api/const";

async function check_auth_token(next, from, to) {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("url_code")) {
    try {
      let payload = {
        url_code: urlParams.get("url_code"),
      };
      let result = await api.auth.register(payload);
      result = result["data"];
      if (result["is_registered"]) {
        localStorage.removeItem("auth_token");
        localStorage.setItem("profile_id", result["id"]);
        localStorage.setItem("auth_token", result["auth_token"]);
        localStorage.setItem("profile_firstName", result["first_name"]);
        localStorage.setItem("profile_lastName", result["last_name"]);
        localStorage.setItem("profile_middleName", result["middle_name"]);
        localStorage.setItem("profile_gender", result["gender"]);
        localStorage.setItem("profile_birthday", result["birthday"]);
        localStorage.setItem("profile_email", result["email"]);
        localStorage.setItem("profile_phone", result["phone"]);
        localStorage.setItem("profile_telegram", result["telegram"]);
        localStorage.setItem("profile_instagram", result["instagram"]);
        localStorage.setItem("profile_vk", result["vk"]);
        localStorage.setItem("profile_comment", result["comment"]);
        localStorage.removeItem("isPageCheckout");
        let avatar = result["avatar"];
        if (avatar.indexOf("media") !== -1) {
          avatar = Const.API_URL + avatar;
        } else if (avatar !== "") {
          avatar = Const.API_URL + "media/" + avatar;
        }
        localStorage.setItem("profile_avatar", avatar);
        let href = String(window.location.href).split("?")[0];
        let order_id = urlParams.get("order_id");
        if (order_id) href = href + "?order_id=" + order_id;
        let ooi = urlParams.get("open_order_id");
        if (ooi) href = href + "?open_order_id=" + ooi;
        window.location.href = href;
      } else next(to);
    } catch (error) {
      next(to);
    }
  } else if (localStorage.getItem("auth_token")) {
    next(from);
  } else {
    next(to);
  }
}

const routes = [
  {
    path: "/",
    name: "main",
    component: () => import("@/views/MainView.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/LogoutView.vue"),
  },
  {
    path: "/personal",
    name: "personal",
    component: () => import("@/views/PersonalView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/settings",
    name: "personal_settings",
    component: () => import("@/views/PersonalSettingsView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/orders",
    name: "personal_orders",
    component: () => import("@/views/PersonalOrdersView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/returns",
    name: "personal_returns",
    component: () => import("@/views/PersonalReturnsView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/loyalty-program",
    name: "personal_loyalty_program",
    component: () => import("@/views/PersonalLoyaltyProgramView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/products",
    name: "personal_products",
    component: () => import("@/views/PersonalProductsView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/purchases",
    name: "personal_purchases",
    component: () => import("@/views/PersonalPurchasesView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/recommendations",
    name: "personal_recommendations",
    component: () => import("@/views/PersonalRecommendationsView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/notifications",
    name: "personal_notifications",
    component: () => import("@/views/PersonalNotificationsView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/questionnaire",
    name: "personal_questionnaire",
    component: () => import("@/views/PersonalQuestionnaireView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/questionnaire/:path_attempt",
    name: "questionnaire_attempt",
    component: () => import("@/views/QuestionnaireAttemptView.vue"),
  },
  {
    path: "/personal/questionnaire/:path_attempt/result",
    name: "questionnaire_attempt_result",
    component: () => import("@/views/QuestionnaireAttemptResultView.vue"),
  },
  {
    path: "/personal/medicine-chest",
    name: "personal_medicine_chest",
    component: () => import("@/views/PersonalMedicineChestView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/deliveries",
    name: "personal_deliveries",
    component: () => import("@/views/PersonalDeliveriesView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/payments",
    name: "personal_payments",
    component: () => import("@/views/PersonalPaymentsView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/partner",
    name: "personal_partner",
    component: () => import("@/views/PersonalPartnerView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/personal/subscriptions",
    name: "personal_subscriptions",
    component: () => import("@/views/PersonalSubscriptionsView.vue"),
    beforeEnter: (to, from, next) => {
      check_auth_token(next, true, "/?is-login=1&next=" + to["fullPath"]);
    },
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("@/views/CartView.vue"),
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import("@/views/CheckoutView.vue"),
  },
  {
    path: "/catalog",
    name: "catalog",
    component: () => import("@/views/CatalogView.vue"),
  },
  {
    path: "/catalog/:path_catalog",
    name: "path_catalog",
    component: () => import("@/views/PathProductView.vue"),
  },
  {
    path: "/catalog/:path_catalog/feedback",
    name: "product_feedback",
    component: () => import("@/views/ProductFeedbackView.vue"),
  },
  {
    path: "/catalog/:path_catalog/questions",
    name: "product_questions",
    component: () => import("@/views/ProductQuestionsView.vue"),
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("@/views/BlogView.vue"),
  },
  {
    path: "/blog/:path_blog",
    name: "path_blog",
    component: () => import("@/views/PathBlogView.vue"),
  },
  {
    path: "/go/:path_stream",
    name: "path_stream",
    component: () => import("@/views/TrackerClickView.vue"),
  },
  {
    path: "/t/:path_tracking",
    name: "path_tracking",
    component: () => import("@/views/AutoTrackerView.vue"),
  },
  {
    path: "/gift-certificate/:path_url",
    name: "path_url",
    component: () => import("@/views/GiftCardView.vue"),
  },
  {
    path: "/promo/:path_promotion",
    name: "path_promotion",
    component: () => import("@/views/PromotionView.vue"),
  },
  {
    path: "/questionnaire/:path_questionnaire",
    name: "path_questionnaire",
    component: () => import("@/views/QuestionnaireView.vue"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/SearchView.vue"),
  },
  {
    path: "/:path_page",
    name: "path_page",
    component: () => import("@/views/PathPageView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
